/* eslint-disable */
/**
 * The path of the `LoginPage` to be consumed by a `<Router />`
 * @export
 */
export const LOGIN_PAGE_PATH = `/login`;

/**
 * Create a `href` that will resolve to `LoginPage`
 * @export
 * @returns {string} The `LOGIN_PAGE_PATH`
 */
export const createLoginPageLink = () => LOGIN_PAGE_PATH;

/**
 * Determine if the current page is the `LoginPage`
 * @export
 * @param {RouterMatch<any>} match The `react-router-dom`'s `match` params
 * @returns {boolean} Whether or not the current page is `LoginPage`
 */
export const isLoginPage = (match) => match.path === LOGIN_PAGE_PATH;
